import { render, staticRenderFns } from "./VirtualScroller.vue?vue&type=template&id=680ed2bd&scoped=true"
import script from "./VirtualScroller.vue?vue&type=script&lang=js"
export * from "./VirtualScroller.vue?vue&type=script&lang=js"
import style0 from "./VirtualScroller.vue?vue&type=style&index=0&id=680ed2bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ed2bd",
  null
  
)

export default component.exports